module.exports = __webpack_public_path__ + "img/chr_ts_23_penlight.d1eb768d.png";